module.exports = __webpack_public_path__ + "img/picture_viptk@2x.d804acac.png";